import { List } from "@radix-ui/react-tabs";


rem;
import styled from "styled-components";

import { alignItemsCenter, rem } from "@styles/Utilities.styled";


export const StyledTabsList = styled(List)`
  ${alignItemsCenter}
  gap: 0.25rem;
  padding: 0.4em;
  width: fit-content;
  background-color: var(--clr-gray-100);
  border-radius: var(--border-radius-2);

  .tabs-trigger {
    padding: 0.6em 1.5em;
    font-size: ${rem(14)};
    color: var(--clr-primary-700);
    white-space: nowrap;

    &[data-state="active"] {
      color: var(--clr-white);
      background-color: var(--mantine-color-primary-6);
      border-radius: var(--border-radius-2);
    }

    &[data-disabled] {
      color: var(--clr-gray-200);
      cursor: not-allowed;
    }
  }
`;
